<template>
    <div>
        <form @submit.prevent="onSubmit">
            <div class="title-container" v-bind:style="{ background: '#0082C8' }">
                <h2 class="search-title">{{ searchboxheadlineflighthelp[getCurrentLocale] }}</h2>
                <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
                <i class="soap-icon-hotel"></i>
            </div>


            <div class="search-content" style="padding-top: 20px; background-color: #fff;">
                <h4 class="skin-color">{{ infotexttitle[getCurrentLocale] }}</h4>
                <p v-html="infotext[getCurrentLocale]"></p>
                <img src="/res/images/slrh65.png" style="float:right;">

                <!-- >>> Departure/Destination -->
                <h5 class="title" style="margin-top: 50px;">{{ where[getCurrentLocale] }}</h5>
                <div class="row">
                    <div class="col-xs-6">
                        <label>{{ yourplaceofdeparture[getCurrentLocale] }}:</label>
                        <v-select name="depArprtCodeTours" ref="depArprtCodeTours"
                            :clearable="false"
                            :disabled="!departuresLoadedTours"
                            v-model="depArprtCodeTours"
                            :options="airportsOriginsTours"
                            label="l"
                            key="i"
                            :value="i"
                            class="style-chooser"
                            :placeholder="this.departureairport[this.getCurrentLocale]"
                            @input="call_listAirportsDestinations">
                        </v-select>
                    </div>

                    <div class="col-xs-6">
                        <label>{{ yourplaceofdestination[getCurrentLocale] }}:</label>
                        <v-select name="desArprtCodeTours" ref="desArprtCodeTours"
                            :clearable="false"
                            :disabled="!destinationsLoadedTours"
                            v-model="desArprtCodeTours"
                            :options="airportsDestinationsTours"
                            label="l"
                            key="i"
                            :value="i"
                            class="style-chooser"
                            :placeholder="this.destinationairport[this.getCurrentLocale]">
                        </v-select>
                    </div>
                </div>


                <hr>


                <!-- >>> Date Dep/Date Des -->
                <h5 class="title">{{ when[getCurrentLocale] }}</h5>
                <div class="row">
                    <div class="col-xs-6">
                        <label>{{ departuredate[getCurrentLocale] }}:</label>
                        <div class="datepicker-wrap sundair">
                            <input type="text" name="date_from" class="input-text full-width" placeholder="dd.mm.yy" :value="today">
                        </div>
                    </div>

                    <div class="col-xs-6">
                        <label v-show="outwardonly === false">{{ returndate[getCurrentLocale] }}:</label>
                        <div class="datepicker-wrap sundair" v-show="outwardonly === false">
                            <input type="text" name="date_to" class="input-text full-width" placeholder="dd.mm.yy" :value="tommorow">
                        </div>
                    </div>
                </div>


                <hr>


                <!-- >>> Travel Time from/to (#475) -->
                <div class="row">
                    <div class="col-xs-6">
                        <label>{{ traveltimefrom[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="traveltimeFrom">
                                <option v-for="(value, index) in 28" :value="value" :key="index" :selected="value === 7">{{ value }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-xs-6">
                        <label>{{ traveltimeto[getCurrentLocale] }}:</label>
                           <div class="selector">
                            <select ref="traveltimeTo">
                                <option v-for="(value, index) in 28" :value="value" :key="index" :selected="value === 14">{{ value }}</option>
                            </select>
                        </div>
                    </div>
                </div>


                <hr>


                <!-- >>> Who? -->
                <h5 class="title">{{ who[getCurrentLocale] }}</h5>
                <div class="row">
                    <div class="col-xs-4 col-md-4">
                        <label>{{ adult[getCurrentLocale] }}<br>{{ adultyears[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="noADT_Tours">
                                <option v-for="(value, key) in listOfPaxes" :value="value" :key="key" :selected="value === '1'">{{ value }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-4 col-md-4">
                        <label>{{ child[getCurrentLocale] }}<br>{{ childyears[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="noCHD_Tours">
                                <option v-for="(value, key) in listOfPaxes" :value="value" :key="key">{{ value }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-4 col-md-4">
                        <label>{{ infant[getCurrentLocale] }}<br>{{ infantyears[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="noINF_Tours">
                                <option v-for="(value, key) in listOfPaxes" :value="value" :key="key">{{ value }}</option>
                            </select>
                        </div>
                    </div>
                </div>


                <br /><br /><hr>


                <!-- >>> Submit -->
                <button type="submit" class="btn-medium icon-check-srvcs uppercase full-width"  v-bind:style="{ background: '#0082C8' }">{{ findflights[getCurrentLocale] }}</button>
                <!-- <a class="button btn-medium uppercase full-width silver" v-if="depArprtCode === '' || desArprtCode === ''">{{ findflights[getCurrentLocale] }} </a> -->
            </div>
        </form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import axios from 'axios';
    import moment from 'moment';


    export default {

        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                searchboxheadlineflighthelp: {
                    en: 'Package tour',
                    de: 'Pauschalreise',
                },
                searchboxheadlineflights2: {
                    en: 'in cooperation with schauinsland-reisen',
                    de: 'in Kooperation mit schauinsland-reisen',
                },
                infotexttitle: {
                    de: 'Pauschalreisen suchen und buchen? Kein Problem!',
                    en: 'Search and book package tours? No problem!',
                },
                infotext: {
                    de: 'Nach der Auswahl Ihres gewünschten Zielgebietes werden Sie zu unserem Partner schauinsland-reisen weitergeleitet und können dort Ihre Wunschreise buchen.',
                    en: 'After selecting your desired destination, you will be redirected to our Partner schauinsland-reisen where you can book your desired trip.',
                },

                // ----------------------------------
                where: {
                    en: 'Where',
                    de: 'Wohin',
                },
                yourplaceofdeparture: {
                    en: 'YOUR DEPARTURE',
                    de: 'IHR ABFLUGSORT',
                },
                yourplaceofdestination: {
                    en: 'YOUR DESTINATION',
                    de: 'IHR ZIELORT',
                },
                departureairport: {
                    en: 'Please choose your departure airport',
                    de: 'Wählen Sie Ihren Startflughafen',
                },
                destinationairport: {
                    en: 'Please choose your destination airport',
                    de: 'Wählen Sie Ihren Zielflughafen',
                },
                // ----------------------------------
                when: {
                    en: 'When',
                    de: 'Wann',
                },
                departuredate: {
                    en: 'Earliest date of departure',
                    de: 'Frühste Hinreise',
                },
                returndate: {
                    en: 'Latest date of return',
                    de: 'Späteste Rückreise',
                },
                traveltimefrom : {
                    en: 'Travel time from',
                    de: 'Reisedauer ab',
                },
                traveltimeto : {
                    en: 'Travel time to',
                    de: 'Reisedauer bis',
                },
                // ----------------------------------
                who: {
                    en: 'Who',
                    de: 'Wer',
                },
                adult: {
                    en: 'Adults',
                    de: 'Erwachsene',
                },
                adultyears: {
                    en: '(From 12+ Years)',
                    de: '(Ab 12+ Jahre)',
                },
                child: {
                    en: 'Children',
                    de: 'Kinder',
                },
                childyears: {
                    en: '(2 to 12 Years)',
                    de: '(2 bis 12 Jahre)',
                },
                infant: {
                    en: 'Infants',
                    de: 'Kleinkinder',
                },
                infantyears: {
                    en: '(Up to 2 Years)',
                    de: '(Bis 2 Jahre)',
                },
                // ----------------------------------
                findflights: {
                    en: 'FIND PACKAGE TOUR',
                    de: 'PAUSCHALREISE FINDEN',
                },
                // >>> --------------------------
                nodestinationfound: {
                    en: 'We cannot offer package tours for this route.',
                    de: 'Für diese Strecke können wir Ihnen keine Pauschalreisen anbieten.',
                },
                // currentLocale: 'de',
                // >>> ---------------------------------------------------------
                // >>> ---------------------------------------------------------
                airportsOriginsTours        : [],
                airportsDestinationsTours   : [],
                departuresLoadedTours       : false,
                destinationsLoadedTours     : false,    // Des Aiports loaded?

                desArprtCodeTours           : '',       // model, new select Field
                depArprtCodeTours           : '',       // model, new sselect Field

                outwardonly                 : false,    // ReturnFlight too?
                today                       : moment().add(2, 'days').format('DD.MM.YYYY'),
                tommorow                    : moment().add(62, 'days').format('DD.MM.YYYY'),

                listOfPaxes                 : { 0: '0', 1: '1', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8' },
                noADT                       : 1,
            };

        }, // eo function data()
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            var me = this;


            me.$toc('>>> shared/forms/PackageToursTab.vue >>> created');
            this.call_listAirportsOrigines();

        }, // eo function created()

        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc: Initialize Select Fields.
        * Note:
        *
        */
        mounted: function() {

            var me = this;


            me.$toc('>>> shared/forms/PackageToursTab.vue >>> mounted');
            me.$selectInits('booking', this.getCurrentLocale);

        },  // eo function mounted()

        /***********************************************************************
        * Lifecyclehook::updated
        *
        * Desc:
        * Note:
        *
        */
        updated: function() {

            var me = this;


            me.$toc('>>> shared/forms/PackageToursTab.vue >>> updated');
            me.$selectInits('booking', this.getCurrentLocale);

        },  // eo function updated()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * Call::'/booking/origines'
            * Call::'/registration/destinations/ZRH'
            *
            * Desc: Getting Airports - Origines ('listAirports').
            * Note:
            *
            */
            call_listAirportsOrigines: function() {

                var me = this,
                    hdrs = '',
                    url = '/booking/origines/';


                me.$toc('>>> shared/forms/PackageToursTab.vue >>> call_listAirportsOrigines');
                // >>> Send Ajax Request ---------------------------------------
                // me.$vp_m();
                axios.get(url)
                    .then(function(response) { // 'OK'
                        // me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.airportsOriginsTours = response.data.originesRS.dep;
                                me.airportsOriginsTours.sort((a,b) => (a.l > b.l) ? 1 : ((b.l > a.l) ? -1 : 0));
                                me.departuresLoadedTours = true;
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        // me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eo funtion call_listAirportsOrigines()


            /*******************************************************************
            * Call::'/booking/destinations/ZRH'
            * Call::'/registration/destinations/ZRH'
            *
            * Desc: Getting Airports - Destinations ('listAirports').
            * Note:
            *
            */
            call_listAirportsDestinations: function(event) {

                var me = this,
                    hdrs = '',
                    url = '/booking/destinations/';


                me.$toc('>>> shared/forms/PackageToursTab.vue >>> call_listAirportsOrigines');
                this.desArprtCodeTours = ''; // reset model
                // this.onChange_FlightsSearchForm(); // reset

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.get(url + event.i)
                    .then(function(response) {  // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.airportsDestinationsTours = response.data.destinationsRS.des;
                                me.airportsDestinationsTours.sort((a,b) => (a.l > b.l) ? 1 : ((b.l > a.l) ? -1 : 0));
                                me.destinationsLoadedTours = true;
                                break;
                            default: // 'ERROR'
                                // me.$toc('I am in Header Error');
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eo funtion call_listAirportsDestinations()




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: SearchForm gets submitted.
            * Note: https://www.schauinsland-reisen.de/search?destination=PMI&
            * Note: date=14082020|21082020&duration=5|7&
            * NOte: travellers=01011988|01011988|13092014&departure=KSF&airline=SR';
            *
            */
            onSubmit: function (submitEvent) {

                let me = this,
                    listOfDestinations = [
                        { key: 'PMI', des: 'mallorca' },
                        { key: 'FUE', des: 'fuerteventura' },
                        { key: 'LPA', des: 'gran_canaria' },
                        { key: 'TFS', des: 'teneriffa' },
                        { key: 'CFU', des: 'korfu' },
                        { key: 'HER', des: 'kreta' },
                        { key: 'KGS', des: 'kos' },
                        { key: 'RHO', des: 'rhodos' },
                        { key: 'BOJ', des: 'burgas' },
                        { key: 'VAR', des: 'bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar' },
                        { key: 'AYT', des: 'antalya_belek' },
                        { key: 'HRG', des: 'hurghada' },
                        { key: 'BEY', des: 'beirut' },
                        { key: 'BWK', des: 'kroatien_insel_brac' },
                        { key: 'DJE', des: 'tunesien_insel_djerba' },
                        { key: 'ACE', des: 'lanzarote' },
                        { key: 'LCA', des: 'zypern' },
                    ],
                    url = '',
                    destination = null,                                         // PMI
                    dateFrom = null,                                            // 14082020|21082020
                    dateTo = null,                                              // 14082020|21082020
                    tmp1 = null,
                    tmp2 = null,
                    start = null,
                    end = null,
                    duration = null,                                            // 5 (days)
                    traveltimeFrom = this.$refs.traveltimeFrom.value,
                    traveltimeTo = this.$refs.traveltimeTo.value,
                    travellers = '',                                            // 01011988|01011988|13092014
                    noADT = this.$refs.noADT_Tours.value,                       // this.noADT,
                    noCHD = this.$refs.noCHD_Tours.value,                       // this.noCHD,
                    noINF = this.$refs.noINF_Tours.value,                       // this.noINF,
                    birthDateADT = null,
                    birthDateCHD = null,
                    birthDateINF = null,
                    departure = null,                                           // KSF
                    baseUrl = 'https://www.schauinsland-reisen.de/search?';


                me.$toc('>>> shared/forms/PackageToursTab.vue >>> onSubmit');
                departure = this.depArprtCodeTours.i;

                destination = listOfDestinations.find(item => item.key === this.desArprtCodeTours.i);
                if (destination === undefined) {
                    me.$toasted.global.sdr_app_error({
                        message : this.nodestinationfound[this.getCurrentLocale]
                    });
                    return;
                }

                destination = destination.des;


                // >>> -------------------------------------------------------- // 'date'
                dateFrom = submitEvent.target.elements.date_from.value.split('.').join("");
                dateTo = submitEvent.target.elements.date_to.value.split('.').join("");

                // >>> -------------------------------------------------------- // 'duration'
                tmp1 = submitEvent.target.elements.date_from.value.split('.');
                tmp2 = submitEvent.target.elements.date_to.value.split('.');
                start = tmp1[2] + '' + tmp1[1] + '' + tmp1[0]; // new: date format change @slr
                end = tmp2[2] + '' + tmp2[1] + '' + tmp2[0]; // new: date format change @slr
                // duration = moment.duration(end.diff(start)).asDays();
                duration = this.$refs.traveltimeFrom.value + '|' + this.$refs.traveltimeTo.value;


                // >>> -------------------------------------------------------- // 'travellers'
                birthDateADT = moment(dateFrom, 'DD.MM.YYYY').subtract(20, 'years').format('DD.MM.YYYY').split('.').join("");
                for (var i = 0; i < noADT; i++) {
                    travellers += birthDateADT + '|'
                }
                if (noCHD === 0) {
                    travellers = travellers.substring(0, travellers.length - 1); // del last char
                }

                birthDateCHD = moment(dateFrom, 'DD.MM.YYYY').subtract(5, 'years').format('DD.MM.YYYY').split('.').join("");
                for (var i = 0; i < noCHD; i++) {
                    travellers += birthDateCHD + '|'
                }
                if (noINF === 0) {
                    travellers = travellers.substring(0, travellers.length - 1); // del last char
                }

                birthDateINF = moment(dateFrom, 'DD.MM.YYYY').subtract(1, 'years').format('DD.MM.YYYY').split('.').join("");
                for (var i = 0; i < noINF; i++) {
                    travellers += birthDateINF + '|'
                }
                travellers = travellers.substring(0, travellers.length - 1); // del last char



                // >>> -------------------------------------------------------- // concenate
                url += 'destination=' + destination + '&';
                url += 'date=' + start + '-' + end + '&';                       // OK
                url += 'duration=' + duration + '&';                            // OK
                url += 'travellers=' + travellers + '&';                        // OK
                url += 'departure=' + departure + '&';
                url += 'airline=SR';                                            // OK

                window.open(baseUrl + url, "_blank");

            }, // eof onSubmit()

        }, // eo  methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .icon-box.style5 > i {
        background: #9F4378;
    }
    .icon-box.style5 {
        background: #f5f5f5;
    }





    /* package tpurs */
    .style-chooser-tours .vs__search::placeholder,
    .style-chooser-tours .vs__dropdown-toggle,
    .style-chooser-tours .vs__dropdown-menu {
        background: #0082C8;
        color: #ffffff;
    }

    .style-chooser-tours .vs__clear,
    .style-chooser-tours .vs__open-indicator {
        fill: #ffffff;
    }

    .style-chooser-tours .vs__dropdown-toggle,
    .style-chooser-tours .vs--disabled .vs__open-indicator,
    .style-chooser-tours .vs--disabled .vs__search,
    .style-chooser-tours .vs--disabled .vs__selected {
        background-color: #0082C8;
    }

   .style-chooser-tours .vs--disabled {
        background-color: #0082C8 !important;
        color: #fff;
    }

    /* EDGE - Menue, Background (Order: Booking, Services) */
    .style-chooser-srvcs .vs__dropdown-menu {
        background: #0082C8;
        color: #ffffff;
    }

    /* EDGE - Schriftfarbe (Booking, Servies) */
    .vs--disabled .vs__open-indicator,
    .vs--disabled .vs__search,
    .vs--disabled .vs__selected,
    .vs__dropdown-toggle{
        color: #fff;
    }



    .icon-check-srvcs {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check-srvcs:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #0082C8;
    }


    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        .search-box-wrapper.style1 .search-tab-content .search-content {
            padding: 18px 25px 25px;
            padding-top: 18px;
            padding-right: 10px;
            padding-bottom: 10px;
            padding-left: 10px;
        }
    }

</style>